<div class="flex " [class.w-full]="fullWidth">
  <label class="flex flex-col min-w-40 flex-1">
    <p class="text-sm font-medium text-metro-black mb-1 block">
      {{ label }}
      @if (required) { <span class="text-red-600">*</span> }
    </p>

    <textarea
      #textareaEl
      [rows]="rows"
      [attr.placeholder]="placeholder"
      [attr.maxlength]="maxlength ?? null"
      [disabled]="disabled"
      [value]="value"
      (input)="onInput($event)"
      (focus)="focused.emit()"
      (blur)="blurred.emit()"
      [attr.aria-invalid]="!!error"
      [attr.aria-required]="required || null"
      class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg input-base px-2 py-1 text-base font-normal leading-normal
             disabled:opacity-50 disabled:cursor-not-allowed {{ minHeightClass }}"
    ></textarea>

    @if (error) {
      <span class="mt-1 text-sm text-red-600">{{ error }}</span>
    } @else if (hint) {
      <span class="mt-1 text-sm text-[#4e7a97]">{{ hint }}</span>
    }
  </label>
</div>
